/* eslint-disable import/prefer-default-export */
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../store/auth';
import breadcrumbsReducer from '../store/breadcrumbs';
import channelHashReducer from '../applications/payment-configuration/store/channel-hashes';
import conversionRatesReducer from '../applications/conversion-rates/store/conversion-rates.reducer';
import currencyDetailsReducer from '../applications/payment-configuration/store/currency-details';
import errorConfigReducer from '../applications/payment-configuration/store/error-config';
import dashboardReducer from '../store/dashboard';
import formsReducers from '../store/forms';
import logExplorerReducer from '../store/log-explorer';
import monitoringDashboardReducer from '../store/monitoring-dashboard';
import paymentConfigReducer from '../applications/payment-configuration/store/payment-config';
import paymentOptionsReducer from '../applications/payment-options/store/payment-options';
import legacyPaymentOptionsReducer from '../applications/legacy-payment-options/store/legacy-payment-options.reducer';
import paymentOrchestrationReducer from '../applications/payment-orchestration/store/payment-orchestration.reducer';
import paymentSearchReducer from '../applications/payment-search/store/payment-search.reducer';
import smartAlertsReducer from '../store/smart-alerts';
import togglesReducer from '../applications/payment-configuration/store/toggles';
import userManagementReducer from '../applications/user-management/store/user-management.reducer';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    breadcrumbs: breadcrumbsReducer,
    channelHash: channelHashReducer,
    conversionRates: conversionRatesReducer,
    currencyDetails: currencyDetailsReducer,
    errorConfig: errorConfigReducer,
    dashboard: dashboardReducer,
    forms: formsReducers,
    logExplorer: logExplorerReducer,
    monitoringDashboard: monitoringDashboardReducer,
    paymentConfig: paymentConfigReducer,
    paymentOptions: paymentOptionsReducer,
    legacyPaymentOption: legacyPaymentOptionsReducer,
    paymentOrchestration: paymentOrchestrationReducer,
    paymentSearch: paymentSearchReducer,
    smartAlerts: smartAlertsReducer,
    toggles: togglesReducer,
    userManagement: userManagementReducer,
  },
});
